export const firebaseConfig = {

    apiKey: "AIzaSyAd6GZAMBs_A_JErUt9GBRK3liRBb31l_Q",
  
    authDomain: "qid-production.firebaseapp.com",
  
    databaseURL: "https://qid-production-default-rtdb.firebaseio.com",
  
    projectId: "qid-production",
  
    storageBucket: "qid-production.firebasestorage.app",
  
    messagingSenderId: "1036563059652",
  
    appId: "1:1036563059652:web:c8fbbb9e4660b552bd4a91",
  
    measurementId: "G-GB6J4XC7NQ"
  
  };
  
  